module.exports = __webpack_public_path__ + "img/ping3.31ea0103.png";